import React, {useEffect, useState} from 'react';
import IconTextView, {INPUT_TYPE} from "../../../components/input/IconTextView";
import {authenticationViewModel} from "../../../viewModels/Authentication.viewModel";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";
import messages from "res/messages/farsi";
import {useHistory} from "react-router-dom";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import SelectableItemList from "../../../components/list/SelectableItemList";
import {getButtonHeight, getSmallTextViewHeight, getTextViewHeight, IsF, IsM, IsSM, IsT} from "my-styles/media/media";
import IconTitleValue from "components/textValue/IconTitleValue";

import ICMale from "res/images/male.png";
import ICMaleWhite from "res/images/male_white.png";
import ICFemale from "res/images/female.png";
import ICFemaleWhite from "res/images/female_white.png";
import ICEdit from "res/images/edit_white.png";
import ICUserAccount from "res/images/user.png";
import ICInvite from "res/images/title.png";
import ICPhone from "res/images/phone.png";
import ICId from "res/images/orders.png";
import ICBirthDate from "res/images/calendar.png";
import ICEmail from "res/images/message.png";
import ICFantasticBg1 from "res/images/fantastic_bg_1.png";
import ICFantasticBg2 from "res/images/fantastic_bg_2.png";
import ICProfileImage from "res/images/profile_image.png";

export default function Profile(props) {

    const history = useHistory()

    const [isCancelled, setIsCancelled] = useState(false)
    const [user, setUser] = useState()
    const [gender, setGender] = useState()
    const [fullName, setFullName] = useState()
    const [email, setEmail] = useState()
    const [nationalId, setNationalId] = useState()
    const [day, setDay] = useState()
    const [month, setMonth] = useState()
    const [year, setYear] = useState()

    function requestEditProfile() {
        let birthdate = ""
        let yy = year
        let mm = month
        let dd = day
        if (yy || mm || dd) {
            if (yy && mm && dd && yy !== "0000" && mm !== "00" && dd !== "00") {
                if (mm && mm.length === 1 && !mm.startsWith("0")) {
                    mm = "0" + mm
                }
                if (dd && dd.length === 1 && !dd.startsWith("0")) {
                    dd = "0" + dd
                }
                birthdate = yy + "-" + mm + "-" + dd
                if (birthdate.length !== 10) {
                    props.onAlert(messages.birthdateError)
                    return
                }
            } else {
                props.onAlert(messages.birthdateError)
                return
            }
        }

        authenticationViewModel.requestEditUser(
            fullName,
            email,
            nationalId,
            birthdate,
            gender,
            () => {
                props.onAlert(messages.editProfileSuccess, ALERT_TYPES.SUCCESS)
                props.onNavigate(history, "/")
            }, (data) => {
                if (data !== undefined && data.description !== undefined) {
                    if (data.description === 190 || data.description === 191) {
                        props.onAlert(data.error_message)
                    } else if (data.description === 193) {
                        props.onAlert(messages.emailError)
                    } else if (data.description === 194) {
                        props.onAlert(messages.emailDupliate)
                    } else if (data.description === 195) {
                        props.onAlert(messages.nationalIdError)
                    } else if (data.description === 197) {
                        props.onAlert(messages.birthdateError)
                    }
                }
            }, () => {
                props.onLoading(true)
            }, () => {
                props.onLoading(false)
            }
        )
    }

    useEffect(() => {
        authenticationViewModel.user.subscribe((user) => {
            if (isCancelled) return

            setUser(user)
            if (user) {
                setGender(user.gender)
                setFullName(user.full_name)
                setEmail(user.email)
                setNationalId(user.meli_code)
                if (user.date_born) {
                    let splits = user.date_born.split("-")
                    if (splits && splits.length === 3) {
                        setYear(splits[0])
                        setMonth(splits[1])
                        setDay(splits[2])
                    }
                }
            }
        })

        return () => {
            setIsCancelled(true)
        }
    }, [isCancelled])

    return (IsSM() || IsM() ?
        <div className="marginSmall background" style={{backgroundImage: 'url(' + ICFantasticBg2 + ')'}}>
            <table className="fullWidth center" style={{height: "30em"}}>
                <tbody>
                <tr>
                    <td>
                        {user &&
                        <center>
                            <div style={{width: "70%"}}>
                                <IconTextView
                                    height={getTextViewHeight()}
                                    disabled={true}
                                    placeholder={messages.telephone}
                                    defaultValue={user.telephone}
                                    icon={<img alt={"صرفه مارکت"} src={ICPhone}
                                               className="marginSmall xSmallIcon"/>}
                                    onEnterClick={() => {
                                        requestEditProfile()
                                    }}/>
                            </div>
                            <div style={{width: "70%"}}>
                                <IconTextView
                                    height={getTextViewHeight()}
                                    disabled={true}
                                    placeholder={messages.yourInviteCode}
                                    defaultValue={messages.yourInviteCode + ": " + user.customer_id}
                                    icon={<img alt={"صرفه مارکت"} src={ICInvite}
                                               className="marginSmall xSmallIcon"/>}
                                    onEnterClick={() => {
                                        requestEditProfile()
                                    }}/>
                            </div>
                            <div style={{width: "70%"}}>
                                <IconTextView
                                    height={getTextViewHeight()}
                                    placeholder={messages.fullName}
                                    defaultValue={user.full_name}
                                    icon={<img alt={"صرفه مارکت"} src={ICUserAccount}
                                               className="marginSmall xSmallIcon"/>}
                                    onChange={(e) => {
                                        setFullName(e.target.value)
                                    }}
                                    onEnterClick={() => {
                                        requestEditProfile()
                                    }}/>
                            </div>
                            <div style={{width: "70%"}}>
                                <IconTextView
                                    height={getTextViewHeight()}
                                    placeholder={messages.email}
                                    defaultValue={user.email}
                                    icon={<img alt={"صرفه مارکت"} src={ICEmail} className="marginSmall xSmallIcon"/>}
                                    onChange={(e) => {
                                        setEmail(e.target.value)
                                    }}
                                    onEnterClick={() => {
                                        requestEditProfile()
                                    }}/>
                            </div>
                            <div style={{width: "70%"}}>
                                <IconTextView
                                    height={getTextViewHeight()}
                                    placeholder={messages.nationalId}
                                    type={INPUT_TYPE.NUMBER}
                                    maxlength="10"
                                    defaultValue={user.meli_code}
                                    icon={<img alt={"صرفه مارکت"} src={ICId} className="marginSmall xSmallIcon"/>}
                                    onChange={(e) => {
                                        setNationalId(e.target.value)
                                    }}
                                    onEnterClick={() => {
                                        requestEditProfile()
                                    }}/>
                            </div>
                            <div className="horizontalScreen" style={{width: "70%"}}>
                                <div className="marginTopSmall marginRightSmall">
                                    <IconTitleValue
                                        titleClassName="smallTextBold"
                                        icon={<img src={ICBirthDate} alt="" className="xxSmallIcon"/>}
                                        title={messages.birthDate}/>
                                </div>
                                <div className="marginLeftSmall">
                                    <IconTextView
                                        type={INPUT_TYPE.NUMBER}
                                        height={getSmallTextViewHeight()}
                                        placeholder={messages.day}
                                        center={true}
                                        defaultValue={day}
                                        onChange={(e) => {
                                            setDay(e.target.value)
                                        }}
                                        onEnterClick={() => {
                                            requestEditProfile()
                                        }}/>
                                </div>
                                <div className="marginLeftSmall">
                                    <IconTextView
                                        type={INPUT_TYPE.NUMBER}
                                        height={getSmallTextViewHeight()}
                                        placeholder={messages.month}
                                        center={true}
                                        defaultValue={month}
                                        onChange={(e) => {
                                            setMonth(e.target.value)
                                        }}
                                        onEnterClick={() => {
                                            requestEditProfile()
                                        }}/>
                                </div>
                                <div className="twoFromThree">
                                    <IconTextView
                                        type={INPUT_TYPE.NUMBER}
                                        height={getSmallTextViewHeight()}
                                        center={true}
                                        defaultValue={year}
                                        placeholder={messages.year}
                                        onChange={(e) => {
                                            setYear(e.target.value)
                                        }}
                                        onEnterClick={() => {
                                            requestEditProfile()
                                        }}/>
                                </div>
                            </div>
                            <div style={{width: "70%"}}>
                                {user &&
                                <table>
                                    <tbody>
                                    <tr>
                                        <td>
                                            <SelectableItemList
                                                shadow={"0px"}
                                                height={getTextViewHeight()}
                                                items={[
                                                    {
                                                        title: messages.male,
                                                        icon: <img alt={"صرفه مارکت"} src={ICMale} className="xSmallIcon"/>,
                                                        selectedIcon: <img alt={"صرفه مارکت"} src={ICMaleWhite}
                                                                           className="xSmallIcon"/>,
                                                        type: 0,
                                                        selected: user.gender === "0"
                                                    },
                                                    {
                                                        title: messages.female,
                                                        icon: <img alt={"صرفه مارکت"} src={ICFemale} className="xSmallIcon"/>,
                                                        selectedIcon: <img alt={"صرفه مارکت"} src={ICFemaleWhite}
                                                                           className="xSmallIcon"/>,
                                                        type: 1,
                                                        selected: user.gender === "1"
                                                    }
                                                ]}
                                                itemsPerView={2}
                                                onItemSelected={(item) => {
                                                    setGender(item)
                                                }}/>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                }
                            </div>
                            <div style={{width: "70%"}} className="marginTopBottomSmall">
                                <IconTitleButtonRound
                                    height={getButtonHeight()}
                                    fontSize="mediumTextBold"
                                    onClick={() => {
                                        requestEditProfile()
                                    }}
                                    icon={<img alt={"صرفه مارکت"} src={ICEdit} className="marginSmall xSmallIcon"/>}
                                    title={messages.edit}/>
                            </div>
                        </center>
                        }
                    </td>
                </tr>
                </tbody>
            </table>
        </div> :
        IsF() ?
            <div className="marginSmall" style={{
                marginTop: "10em",
                backgroundImage: 'url(' + ICFantasticBg2 + ')',
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
            }}>
                <table className="fullWidth center" style={{height: "35em"}}>
                    <tbody>
                    <tr>
                        <td>
                            {user &&
                            <center>
                                <div style={{width: "55%"}}>
                                    <IconTextView
                                        height={getTextViewHeight()}
                                        disabled={true}
                                        placeholder={messages.telephone}
                                        defaultValue={user.telephone}
                                        icon={<img alt={"صرفه مارکت"} src={ICPhone}
                                                   className="marginSmall xSmallIcon"/>}
                                        onEnterClick={() => {
                                            requestEditProfile()
                                        }}/>
                                </div>
                                <div style={{width: "55%"}}>
                                    <IconTextView
                                        height={getTextViewHeight()}
                                        disabled={true}
                                        placeholder={messages.yourInviteCode}
                                        defaultValue={messages.yourInviteCode + ": " + user.customer_id}
                                        icon={<img alt={"صرفه مارکت"} src={ICInvite}
                                                   className="marginSmall xSmallIcon"/>}
                                        onEnterClick={() => {
                                            requestEditProfile()
                                        }}/>
                                </div>
                                <div style={{width: "55%"}}>
                                    <IconTextView
                                        height={getTextViewHeight()}
                                        placeholder={messages.fullName}
                                        defaultValue={user.full_name}
                                        icon={<img alt={"صرفه مارکت"} src={ICUserAccount}
                                                   className="marginSmall xSmallIcon"/>}
                                        onChange={(e) => {
                                            setFullName(e.target.value)
                                        }}
                                        onEnterClick={() => {
                                            requestEditProfile()
                                        }}/>
                                </div>
                                <div style={{width: "55%"}}>
                                    <IconTextView
                                        height={getTextViewHeight()}
                                        placeholder={messages.email}
                                        defaultValue={user.email}
                                        icon={<img alt={"صرفه مارکت"} src={ICEmail}
                                                   className="marginSmall xSmallIcon"/>}
                                        onChange={(e) => {
                                            setEmail(e.target.value)
                                        }}
                                        onEnterClick={() => {
                                            requestEditProfile()
                                        }}/>
                                </div>
                                <div style={{width: "55%"}}>
                                    <IconTextView
                                        height={getTextViewHeight()}
                                        placeholder={messages.nationalId}
                                        type={INPUT_TYPE.NUMBER}
                                        maxlength="10"
                                        defaultValue={user.meli_code}
                                        icon={<img alt={"صرفه مارکت"} src={ICId} className="marginSmall xSmallIcon"/>}
                                        onChange={(e) => {
                                            setNationalId(e.target.value)
                                        }}
                                        onEnterClick={() => {
                                            requestEditProfile()
                                        }}/>
                                </div>
                                <div className="horizontalScreen" style={{width: "55%"}}>
                                    <div className="marginTopSmall marginRightSmall">
                                        <IconTitleValue
                                            titleClassName="smallTextBold"
                                            icon={<img src={ICBirthDate} alt="" className="xxSmallIcon"/>}
                                            title={messages.birthDate}/>
                                    </div>
                                    <div className="marginLeftSmall">
                                        <IconTextView
                                            type={INPUT_TYPE.NUMBER}
                                            height={getSmallTextViewHeight()}
                                            placeholder={messages.day}
                                            center={true}
                                            defaultValue={day}
                                            onChange={(e) => {
                                                setDay(e.target.value)
                                            }}
                                            onEnterClick={() => {
                                                requestEditProfile()
                                            }}/>
                                    </div>
                                    <div className="marginLeftSmall">
                                        <IconTextView
                                            type={INPUT_TYPE.NUMBER}
                                            height={getSmallTextViewHeight()}
                                            placeholder={messages.month}
                                            center={true}
                                            defaultValue={month}
                                            onChange={(e) => {
                                                setMonth(e.target.value)
                                            }}
                                            onEnterClick={() => {
                                                requestEditProfile()
                                            }}/>
                                    </div>
                                    <div className="twoFromThree">
                                        <IconTextView
                                            type={INPUT_TYPE.NUMBER}
                                            height={getSmallTextViewHeight()}
                                            center={true}
                                            defaultValue={year}
                                            placeholder={messages.year}
                                            onChange={(e) => {
                                                setYear(e.target.value)
                                            }}
                                            onEnterClick={() => {
                                                requestEditProfile()
                                            }}/>
                                    </div>
                                </div>
                                <div style={{width: "55%"}}>
                                    {user &&
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td>
                                                <SelectableItemList
                                                    shadow={"0px"}
                                                    height={getTextViewHeight()}
                                                    items={[
                                                        {
                                                            title: messages.male,
                                                            icon: <img alt={"صرفه مارکت"} src={ICMale} className="xSmallIcon"/>,
                                                            selectedIcon: <img alt={"صرفه مارکت"} src={ICMaleWhite}
                                                                               className="xSmallIcon"/>,
                                                            type: 0,
                                                            selected: user.gender === "0"
                                                        },
                                                        {
                                                            title: messages.female,
                                                            icon: <img alt={"صرفه مارکت"} src={ICFemale} className="xSmallIcon"/>,
                                                            selectedIcon: <img alt={"صرفه مارکت"} src={ICFemaleWhite}
                                                                               className="xSmallIcon"/>,
                                                            type: 1,
                                                            selected: user.gender === "1"
                                                        }
                                                    ]}
                                                    itemsPerView={2}
                                                    onItemSelected={(item) => {
                                                        setGender(item)
                                                    }}/>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    }
                                </div>
                                <div style={{width: "55%"}} className="marginTopBottomSmall">
                                    <IconTitleButtonRound
                                        height={getButtonHeight()}
                                        fontSize="mediumTextBold"
                                        onClick={() => {
                                            requestEditProfile()
                                        }}
                                        icon={<img alt={"صرفه مارکت"} src={ICEdit} className="marginSmall xSmallIcon"/>}
                                        title={messages.edit}/>
                                </div>
                            </center>
                            }
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div> :
            IsT() ?
                <div className="marginSmall" style={{
                    marginTop: "10em",
                    backgroundImage: 'url(' + ICFantasticBg2 + ')',
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }}>
                    <table className="fullWidth center" style={{height: "35em"}}>
                        <tbody>
                        <tr>
                            <td>
                                {user &&
                                <center>
                                    <div style={{width: "40%"}}>
                                        <IconTextView
                                            height={getTextViewHeight()}
                                            disabled={true}
                                            placeholder={messages.telephone}
                                            defaultValue={user.telephone}
                                            icon={<img alt={"صرفه مارکت"} src={ICPhone}
                                                       className="marginSmall xSmallIcon"/>}
                                            onEnterClick={() => {
                                                requestEditProfile()
                                            }}/>
                                    </div>
                                    <div style={{width: "40%"}}>
                                        <IconTextView
                                            height={getTextViewHeight()}
                                            disabled={true}
                                            placeholder={messages.yourInviteCode}
                                            defaultValue={messages.yourInviteCode + ": " + user.customer_id}
                                            icon={<img alt={"صرفه مارکت"} src={ICInvite}
                                                       className="marginSmall xSmallIcon"/>}
                                            onEnterClick={() => {
                                                requestEditProfile()
                                            }}/>
                                    </div>
                                    <div style={{width: "40%"}}>
                                        <IconTextView
                                            height={getTextViewHeight()}
                                            placeholder={messages.fullName}
                                            defaultValue={user.full_name}
                                            icon={<img alt={"صرفه مارکت"} src={ICUserAccount}
                                                       className="marginSmall xSmallIcon"/>}
                                            onChange={(e) => {
                                                setFullName(e.target.value)
                                            }}
                                            onEnterClick={() => {
                                                requestEditProfile()
                                            }}/>
                                    </div>
                                    <div style={{width: "40%"}}>
                                        <IconTextView
                                            height={getTextViewHeight()}
                                            placeholder={messages.email}
                                            defaultValue={user.email}
                                            icon={<img alt={"صرفه مارکت"} src={ICEmail}
                                                       className="marginSmall xSmallIcon"/>}
                                            onChange={(e) => {
                                                setEmail(e.target.value)
                                            }}
                                            onEnterClick={() => {
                                                requestEditProfile()
                                            }}/>
                                    </div>
                                    <div style={{width: "40%"}}>
                                        <IconTextView
                                            height={getTextViewHeight()}
                                            placeholder={messages.nationalId}
                                            type={INPUT_TYPE.NUMBER}
                                            maxlength="10"
                                            defaultValue={user.meli_code}
                                            icon={<img alt={"صرفه مارکت"} src={ICId}
                                                       className="marginSmall xSmallIcon"/>}
                                            onChange={(e) => {
                                                setNationalId(e.target.value)
                                            }}
                                            onEnterClick={() => {
                                                requestEditProfile()
                                            }}/>
                                    </div>
                                    <div className="horizontalScreen" style={{width: "40%"}}>
                                        <div className="marginTopSmall marginRightSmall">
                                            <IconTitleValue
                                                titleClassName="smallTextBold"
                                                icon={<img src={ICBirthDate} alt="" className="xxSmallIcon"/>}
                                                title={messages.birthDate}/>
                                        </div>
                                        <div className="marginLeftSmall">
                                            <IconTextView
                                                type={INPUT_TYPE.NUMBER}
                                                height={getSmallTextViewHeight()}
                                                placeholder={messages.day}
                                                center={true}
                                                defaultValue={day}
                                                onChange={(e) => {
                                                    setDay(e.target.value)
                                                }}
                                                onEnterClick={() => {
                                                    requestEditProfile()
                                                }}/>
                                        </div>
                                        <div className="marginLeftSmall">
                                            <IconTextView
                                                type={INPUT_TYPE.NUMBER}
                                                height={getSmallTextViewHeight()}
                                                placeholder={messages.month}
                                                center={true}
                                                defaultValue={month}
                                                onChange={(e) => {
                                                    setMonth(e.target.value)
                                                }}
                                                onEnterClick={() => {
                                                    requestEditProfile()
                                                }}/>
                                        </div>
                                        <div className="twoFromThree">
                                            <IconTextView
                                                type={INPUT_TYPE.NUMBER}
                                                height={getSmallTextViewHeight()}
                                                center={true}
                                                defaultValue={year}
                                                placeholder={messages.year}
                                                onChange={(e) => {
                                                    setYear(e.target.value)
                                                }}
                                                onEnterClick={() => {
                                                    requestEditProfile()
                                                }}/>
                                        </div>
                                    </div>
                                    <div style={{width: "40%"}}>
                                        {user &&
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <SelectableItemList
                                                        shadow={"0px"}
                                                        height={getTextViewHeight()}
                                                        items={[
                                                            {
                                                                title: messages.male,
                                                                icon: <img alt={"صرفه مارکت"} src={ICMale}
                                                                           className="xSmallIcon"/>,
                                                                selectedIcon: <img alt={"صرفه مارکت"} src={ICMaleWhite}
                                                                                   className="xSmallIcon"/>,
                                                                type: 0,
                                                                selected: user.gender === "0"
                                                            },
                                                            {
                                                                title: messages.female,
                                                                icon: <img alt={"صرفه مارکت"} src={ICFemale}
                                                                           className="xSmallIcon"/>,
                                                                selectedIcon: <img alt={"صرفه مارکت"} src={ICFemaleWhite}
                                                                                   className="xSmallIcon"/>,
                                                                type: 1,
                                                                selected: user.gender === "1"
                                                            }
                                                        ]}
                                                        itemsPerView={2}
                                                        onItemSelected={(item) => {
                                                            setGender(item)
                                                        }}/>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        }
                                    </div>
                                    <div style={{width: "40%"}} className="marginTopBottomSmall">
                                        <IconTitleButtonRound
                                            height={getButtonHeight()}
                                            fontSize="mediumTextBold"
                                            onClick={() => {
                                                requestEditProfile()
                                            }}
                                            icon={<img alt={"صرفه مارکت"} src={ICEdit} className="marginSmall xSmallIcon"/>}
                                            title={messages.edit}/>
                                    </div>
                                </center>
                                }
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div> :
                <div className="horizontalFullScreen">
                    <div className="formContainerLarge marginTopBottomMedium">
                        <img className="lowZIndex full" src={ICFantasticBg2} alt=""/>
                        <table className="full" style={{position: "absolute", top: "0"}}>
                            <tbody>
                            <tr>
                                <td>
                                    {user &&
                                    <center>
                                        <div className="threeFromFive">
                                            <IconTextView
                                                height={getTextViewHeight()}
                                                disabled={true}
                                                placeholder={messages.telephone}
                                                defaultValue={user.telephone}
                                                icon={<img alt={"صرفه مارکت"} src={ICPhone}
                                                           className="marginSmall xSmallIcon"/>}
                                                onEnterClick={() => {
                                                    requestEditProfile()
                                                }}/>
                                        </div>
                                        <div className="threeFromFive">
                                            <IconTextView
                                                height={getTextViewHeight()}
                                                disabled={true}
                                                placeholder={messages.yourInviteCode}
                                                defaultValue={messages.yourInviteCode + ": " + user.customer_id}
                                                icon={<img alt={"صرفه مارکت"} src={ICInvite}
                                                           className="marginSmall xSmallIcon"/>}
                                                onEnterClick={() => {
                                                    requestEditProfile()
                                                }}/>
                                        </div>
                                        <div className="threeFromFive">
                                            <IconTextView
                                                height={getTextViewHeight()}
                                                placeholder={messages.fullName}
                                                defaultValue={user.full_name}
                                                icon={<img alt={"صرفه مارکت"} src={ICUserAccount}
                                                           className="marginSmall xSmallIcon"/>}
                                                onChange={(e) => {
                                                    setFullName(e.target.value)
                                                }}
                                                onEnterClick={() => {
                                                    requestEditProfile()
                                                }}/>
                                        </div>
                                        <div className="threeFromFive">
                                            <IconTextView
                                                height={getTextViewHeight()}
                                                placeholder={messages.email}
                                                defaultValue={user.email}
                                                icon={<img alt={"صرفه مارکت"} src={ICEmail}
                                                           className="marginSmall xSmallIcon"/>}
                                                onChange={(e) => {
                                                    setEmail(e.target.value)
                                                }}
                                                onEnterClick={() => {
                                                    requestEditProfile()
                                                }}/>
                                        </div>
                                        <div className="threeFromFive">
                                            <IconTextView
                                                height={getTextViewHeight()}
                                                placeholder={messages.nationalId}
                                                type={INPUT_TYPE.NUMBER}
                                                maxlength="10"
                                                defaultValue={user.meli_code}
                                                icon={<img alt={"صرفه مارکت"} src={ICId}
                                                           className="marginSmall xSmallIcon"/>}
                                                onChange={(e) => {
                                                    setNationalId(e.target.value)
                                                }}
                                                onEnterClick={() => {
                                                    requestEditProfile()
                                                }}/>
                                        </div>
                                        <div className="threeFromFive horizontalScreen">
                                            <div className="marginTopSmall marginRightSmall">
                                                <IconTitleValue
                                                    titleClassName="smallTextBold"
                                                    icon={<img src={ICBirthDate} alt="" className="xxSmallIcon"/>}
                                                    title={messages.birthDate}/>
                                            </div>
                                            <div className="marginLeftSmall">
                                                <IconTextView
                                                    type={INPUT_TYPE.NUMBER}
                                                    height={getSmallTextViewHeight()}
                                                    placeholder={messages.day}
                                                    center={true}
                                                    defaultValue={day}
                                                    onChange={(e) => {
                                                        setDay(e.target.value)
                                                    }}
                                                    onEnterClick={() => {
                                                        requestEditProfile()
                                                    }}/>
                                            </div>
                                            <div className="marginLeftSmall">
                                                <IconTextView
                                                    type={INPUT_TYPE.NUMBER}
                                                    height={getSmallTextViewHeight()}
                                                    placeholder={messages.month}
                                                    center={true}
                                                    defaultValue={month}
                                                    onChange={(e) => {
                                                        setMonth(e.target.value)
                                                    }}
                                                    onEnterClick={() => {
                                                        requestEditProfile()
                                                    }}/>
                                            </div>
                                            <div className="twoFromThree">
                                                <IconTextView
                                                    type={INPUT_TYPE.NUMBER}
                                                    height={getSmallTextViewHeight()}
                                                    center={true}
                                                    defaultValue={year}
                                                    placeholder={messages.year}
                                                    onChange={(e) => {
                                                        setYear(e.target.value)
                                                    }}
                                                    onEnterClick={() => {
                                                        requestEditProfile()
                                                    }}/>
                                            </div>
                                        </div>
                                        <div className="threeFromFive">
                                            {user &&
                                            <table>
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        <SelectableItemList
                                                            shadow={"0px"}
                                                            height={getTextViewHeight()}
                                                            items={[
                                                                {
                                                                    title: messages.male,
                                                                    icon: <img alt={"صرفه مارکت"} src={ICMale}
                                                                               className="xSmallIcon"/>,
                                                                    selectedIcon: <img alt={"صرفه مارکت"} src={ICMaleWhite}
                                                                                       className="xSmallIcon"/>,
                                                                    type: 0,
                                                                    selected: user.gender === "0"
                                                                },
                                                                {
                                                                    title: messages.female,
                                                                    icon: <img alt={"صرفه مارکت"} src={ICFemale}
                                                                               className="xSmallIcon"/>,
                                                                    selectedIcon: <img alt={"صرفه مارکت"} src={ICFemaleWhite}
                                                                                       className="xSmallIcon"/>,
                                                                    type: 1,
                                                                    selected: user.gender === "1"
                                                                }
                                                            ]}
                                                            itemsPerView={2}
                                                            onItemSelected={(item) => {
                                                                setGender(item)
                                                            }}/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            }
                                        </div>
                                        <div className="threeFromFive marginTopBottomSmall">
                                            <IconTitleButtonRound
                                                height={getButtonHeight()}
                                                fontSize="mediumTextBold"
                                                onClick={() => {
                                                    requestEditProfile()
                                                }}
                                                icon={<img alt={"صرفه مارکت"} src={ICEdit} className="marginSmall xSmallIcon"/>}
                                                title={messages.edit}/>
                                        </div>
                                    </center>
                                    }
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="imageContainer">
                        <img className="leftSideBg" src={ICFantasticBg1} alt={"صرفه مارکت"}/>
                        <img className="leftSideIcon" src={ICProfileImage} alt={"صرفه مارکت"}/>
                    </div>
                </div>)

}